<template>

  <div
    class     = "clips-container"
  >

    <div
      v-for     = "marker in markers"
      class     = "clips-marker"
      :key      = "marker.id"
      :style    = "{
        '--color':    `${marker.color}`,
        top:          '32px',
        left:         marker.start + '%', 
        right:        (100 - marker.end) + '%',
        borderLeft:   '2px solid var(--color)',
        borderRight:  '2px solid var(--color)',
      }"
      @mousedown = "onJumpToClip($event, marker);"
    >
      <div 
        class   = "marker-background"
        :style  = "{
          background: `${marker.color}`
        }"
      >
      </div>

      <v-icon 
        small           
        :color    = "marker.color"
      >
        mdi-content-cut
      </v-icon>

    </div>

  </div>

</template>

<script>

// #region Imports

/* Telestream */
import {
  JUMP_TO_TIME,
  PAUSE_VIDEO
} from '../../../../utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  props: {
    markers: Array
  },
  
  // #endregion Properties

  // #region Methods

  methods: {

    onJumpToClip(event, marker) {
      event.stopPropagation();
      event.preventDefault();
      this.$store.dispatch(JUMP_TO_TIME, marker.time);
      this.$store.dispatch(PAUSE_VIDEO);
    },

  }

  // #endregion Methods
  
}

</script>

<style scoped lang="scss">

.clips-marker {
  position:     absolute;
  text-align:   center;

  .marker-background {
    position:     absolute;
    top:          0;
    right:        0;
    bottom:       0;
    left:         0;

    opacity:      0.1;
  }
}

</style>